import { call, put, takeEvery } from 'redux-saga/effects';
import normalize from 'jsonapi-normalizer';

import { investmentProfile } from '../../../api';
import { resourceReducer } from '../../utils/resourceReducer';

// Create actions and a reducer for the expertAdvice resource
export const [actions, reducer, resourceSagas] = resourceReducer('investment-profiles');

// Create the sagas for this entity
function* readInvestmentProfile() {
  yield takeEvery(actions.indexRequestBegin, function*() {
    try {
      const result = yield call(investmentProfile.get);

      // A user with no investment profile gets `data: null` (a valid empty
      // to-one JSON:API relationship), but normalize() expects a collection.
      result.data = result.data ? [result.data] : [];

      const normalized = normalize(result);
      yield put(actions.indexRequestSuccess(normalized));
    } catch (error) {
      yield put(actions.indexRequestFailure({ error }));
      yield put({ type: 'ERRORS/HANDLE_API_ERROR', payload: error })
    }
  });
}

export const sagas = [readInvestmentProfile, ...resourceSagas];
